/*
 * Author: Harper Yan
 * File Created: Monday, 24-08-05 05:02 pm
 * Last Modified: Monday, 25-03-17 03:18 pm, by Harper Yan
 */

import { styled } from '@mui/material';
import { Flex } from '@ucard/ds/containers';

export const ContentContainer = styled(Flex)(({ theme }) => ({
  background: '#111217',
  flexDirection: 'column',
  // 如果有height 得确保内容超出可滚动
  overflow: 'auto',
  position: 'relative',

  [theme.breakpoints.only('xs')]: {
    borderRadius: 0,
    height: '100%',
  },

  [theme.breakpoints.not('xs')]: {
    borderRadius: '16px',
    height: 'calc(100vh - 64px  - 80px)',
  },
}));
